import React, { useEffect, useState } from "react"
import { Row, Col, Alert, Card, CardBody, Container } from "reactstrap"
import Logo from "assets/images/rema.png"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// import images
import logoSm from "../../assets/images/logo-sm.png"
import Footer from "../../pages/Authentication/Footer"
import { Link } from "react-router-dom"

const RegisterSection = props => {
  const [error, setError] = useState(props.error)
  const [loading, setloading] = useState(false)

  useEffect(() => {
    setError(props.error)
    setloading(false)
  }, [props.error])
  return (
    <>
      <div className="account-pages  ">
        <div
          className="container  justify-content-center d-flex flex-column tw-right-0 tw-left-0 py-5">
          <div className="row pt-5 justify-content-center">
            <div className="col-md-8 col-lg-8  col-xxl-5">
              <div className="card  shadow-md rounded-4">
                <div className="card-body">

                  <div className="d-flex mb-3 justify-content-center">
                    <div
                      className="tw-h-24 d-flex justify-content-center align-items-center tw-w-24 border border-warning border-3 shadow-sm rounded-circle" style={{width:'6rem',height:'6rem'}}>
                      <img src={Logo} alt="Rema Logo" className="img-fluid"/>
                    </div>
                  </div>
                  <h5 className="fw-semibold  text-center">Welcome to REMA Licensing</h5>
                  <p className="text-center text-muted tw-text-xs">Create an Account to start using our services.</p>
                  <div className="p-3">
                    <AvForm
                      className=""
                      onValidSubmit={(e, v) => {
                        props.handleValidSubmit(e, v)
                      }}
                    >
                      {error ? (
                        <Alert color="danger">{props.errorMsg}</Alert>
                      ) : null}
                      <Row>
                        <Col lg={6}>
                          <div className="mb-3">
                            <AvField
                              name="firstName"
                              label="First Name"
                              type="text"
                              required
                              placeholder="Enter first Name"
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <AvField
                              name="lastName"
                              label="Last Name"
                              type="text"
                              required
                              placeholder="Enter Last Name"
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="mb-3">
                        <AvField
                          name="otherNames"
                          label="Other Names"
                          type="text"
                          placeholder="Enter other Names"
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="phone"
                          label="Phone"
                          type="phone"
                          validate={{
                            required: { value: true },
                            maxLength: {
                              value: 10,
                              errorMessage: "Enter a 10 digit phone number.",
                            },
                            minLength: {
                              value: 10,
                              errorMessage: "Enter a 10 digit phone number.",
                            },
                          }}
                          placeholder="Enter Phone Number"
                        />
                      </div>

                      <div className="mb-4">
                        <AvField
                          id="email"
                          name="email"
                          label="Email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          required
                        />
                      </div>

                      <div className="mb-3 row">
                        <div className="col-12 text-end">
                          {loading ? (
                            <Link to="#" className="spinner-border text-info" />
                          ) : (
                            <button
                              className="btn btn-primary w-100 py-2 waves-effect waves-light"
                              type="submit"
                            >
                              Register
                            </button>
                          )}
                        </div>
                      </div>
                    </AvForm>
                    <div className=" text-center">
                      <p>
                        Already have an account ?{" "}
                        <Link to="/login" className="fw-medium text-primary">
                          {" "}
                          Login
                        </Link>{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RegisterSection
